<template>
  <!-- 考核项设置：按 KPI类型(POSITION_ROLE 字典) 手动增删改 -->
  <div class="defaultViewStyle">
    <list-page>
      <div class="kpi-header">
        <form-page :show-page="false" :show-border="false" :show-shadow="false">
          <template #left>📊 考核项设置</template>
          <page-button type="write" el-type="success" @click="openDialog()">+ 新增考核项</page-button>
        </form-page>
      </div>
      <list-table :show-border="false" :show-shadow="false">
        <div v-for="item in kpiTypeList" :key="item.id" class="form-div">
          <form-tag :label="item.dictName" >({{ item.records?item.records.length:'-' }}条，满分合计{{item.capSum}})</form-tag>
          <yq-table :data="item.records" height="auto" stripe border>
            <yq-table-column label="排序" prop="sort" width="90rem" align="center">
              <template v-slot="{row}">{{ row.sort != null ? row.sort : '—' }}</template>
            </yq-table-column>
            <yq-table-column label="考核项名称" prop="kpiName" min-width="180rem">
              <template v-slot="{row}"><strong>{{ row.kpiName || '—' }}</strong></template>
            </yq-table-column>
            <yq-table-column label="KPI 类型" prop="kpiPositionId" min-width="140rem">
              <template v-slot="{row}">
                <el-tag v-if="row.kpiPositionId" size="small">{{ kpiTypeName(row.kpiPositionId) }}</el-tag>
                <span v-else class="muted">—</span>
              </template>
            </yq-table-column>
            <yq-table-column label="说明" prop="description" min-width="220rem" :show-overflow-tooltip="true">
              <template v-slot="{row}"><span v-if="row.description">{{ row.description }}</span><span v-else class="muted">—</span></template>
            </yq-table-column>
            <yq-table-column label="上限分值" prop="cap" width="120rem" align="center">
              <template v-slot="{row}"><strong>{{ row.cap }}</strong></template>
            </yq-table-column>
            <yq-table-column label="操作" prop="options" align="center" fixed="right" width="160rem" :show-overflow-tooltip="false">
              <template v-slot="{row}">
                <table-button @click="openDialog(row)">编辑</table-button>
                <table-button el-type="danger" message="是否确认删除该考核项" @click="deleteRow(row.id)">删除</table-button>
              </template>
            </yq-table-column>
          </yq-table>
        </div>
      </list-table>
    </list-page>

    <!-- 新增/编辑考核项弹窗 -->
    <el-dialog v-model="showDialog" :title="dialogData.id ? '编辑考核项' : '新增考核项'" dialog-width="1" :close-on-click-modal="false">
      <form-items :data="dialogData" :columns="1" label-width="2.4rem" icon-width="0" ref="dialogForm">
        <form-item label="KPI 类型" :required="true" name="kpiPositionId" error-message="请选择 KPI 类型">
          <el-select v-model="dialogData.kpiPositionId" placeholder="请选择" filterable style="width: 100%">
            <el-option v-for="t in kpiTypeList" :key="t.id" :label="t.dictName" :value="t.id"/>
          </el-select>
        </form-item>
        <form-item label="上限分值" :required="true" name="cap" error-message="请填写上限分值" :show-block="true">
          <el-input-number v-model="dialogData.cap" :min="1" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="考核项名称" :required="true" name="kpiName" error-message="请填写考核项名称" :show-block="true">
          <el-input v-model="dialogData.kpiName" placeholder="如：客户拜访量"/>
        </form-item>
        <form-item label="排序">
          <el-input-number v-model="dialogData.sort" :min="0" :align="'right'" style="width: 100%"/>
        </form-item>
        <form-item label="说明" :show-block="true">
          <el-input v-model="dialogData.description" type="textarea" :rows="2" placeholder="该考核项的评估标准"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import kpiItemApi from "@/api/dz-crm/kpi/kpiItemApi";
import commonApi from "@/api/commonApi";
import FormTag from "@/components/h5/layout/FormTag.vue";
import {List} from "@element-plus/icons-vue";
export default {
  setup() {
    return {router: useRouter(), route: useRoute()};
  },
  name: "KpiItemList",
  components: {
    List,
    FormItems, FormItem, YqTableColumn, TableButton, PageButton, FormTag,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      dataList: [],
      kpiTypeList: [],
      showDialog: false,
      dialogData: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    // 加载 KPI类型字典（POSITION_ROLE），供筛选与表单
    commonApi.queryUniqueDictionaryList("POSITION_ROLE").then(res => {
      this.kpiTypeList = res || [];
      this.queryList(); // 查询考核项列表
    });
  },
  methods: {
    kpiTypeName(id) {
      const item = this.kpiTypeList.find(t => t.id === id);
      return item ? item.dictName : id;
    },
    queryList() {
      kpiItemApi.queryList(this.searchInfo).then(list => {
        // 将list填充到kipList
        for (let i = 0; i < this.kpiTypeList.length; i++) {
          this.kpiTypeList[i].records = [];
          for (let j = 0; j < list.length; j++) {
            if (this.kpiTypeList[i].id === list[j].kpiPositionId){
              this.kpiTypeList[i].records.push(list[j]);
            }
          }
          // 添加完成后，进行sum
          for (let j = 0; j < this.kpiTypeList.length; j++) {
            let sum = 0;
            for (let k = 0; k < this.kpiTypeList[i].records.length; k++) {
              sum += this.kpiTypeList[i].records[k].cap;
            }
            this.kpiTypeList[i].capSum = sum;
          }
        }
      });

    },
    openDialog(row) {
      if (row) {
        this.dialogData = JSON.parse(JSON.stringify(row));
      } else {
        this.dialogData = {kpiPositionId: "", sort: 0, kpiName: "", description: "", cap: 25};
      }
      this.showDialog = true;
    },
    async saveData() {
      if (!this.$refs.dialogForm.validCheck()) { // 数据验证不通过
        return;
      }
      await kpiItemApi.save(this.dialogData);
      this.showDialog = false;
      this.queryList();
    },
    async deleteRow(id) {
      await kpiItemApi.delete(id);
      this.queryList();
    },
  },
};
</script>

<style lang="scss" scoped>
.kpi-header{
  border-bottom: 1px solid var(--yq-border-color);
  padding-bottom: 20px !important;
}
.form-div {
  margin-top: 20px;
}
</style>
